export type PaywallRouteDecision = 'allow' | 'home' | 'post-payment-onboarding'

export function resolvePaywallRouteDecision({
  hasPurchased,
  requiresPostPaymentOnboarding,
}: {
  hasPurchased: boolean
  requiresPostPaymentOnboarding: boolean
}): PaywallRouteDecision {
  if (requiresPostPaymentOnboarding) {
    return 'post-payment-onboarding'
  }

  if (!hasPurchased) {
    return 'allow'
  }

  return 'home'
}
